import { State } from '@progress/kendo-data-query';
import { Grid } from '@progress/kendo-react-grid';
import { createRef } from 'react';
import useLineItemSummariesColumns from 'src/assets/static/view_invoice/useViewInvoicesLineItemSummaryColumns';
import GridWrapper from 'src/components/GridWrapper';
import useWindowSize from 'src/hooks/useWindowSize';
import useLineItemSummariesApi from 'src/services/useLineItemSummariesApi';

const defaultProps = {
  showColumnMenu: false,
  sortable: false,
  DataItemKey: 'poId',
};

const initialLineItemSummariesState: State = {
  take: 20,
  skip: 0,
};

interface IClosePoQtyErrorWizard {
  poIds: number[];
}

const ClosePoQtyErrorWizard: React.FC<IClosePoQtyErrorWizard> = ({ poIds }) => {
  const { lineItemSummaries, lineItemSummariesLoading } = useLineItemSummariesApi(poIds?.[0]);
  const { height } = useWindowSize();

  const tableRef = createRef<Grid>();
  const columns = useLineItemSummariesColumns(tableRef);

  return (
    <>
      <div className="mt-1 mb-1 px-1">
        <p className="text-lg font-semibold mb-8">
          The following items will produce an item quantity variance. Please confirm you still want
          to close the PO
          <br />
          No change to the PO will be allowed after it is closed.
        </p>
        <GridWrapper
          id="lineItemSummariesGrid"
          height={height > 420 ? '55vh' : '450px'}
          loading={lineItemSummariesLoading}
          className="lineItemSummariesGrid viewInvoiceModalGrid"
          dataSource={lineItemSummaries}
          dataState={initialLineItemSummariesState}
          total={lineItemSummaries?.length}
          onDataStateChange={() => {}}
          columns={columns}
          {...defaultProps}
        />
      </div>
    </>
  );
};

export default ClosePoQtyErrorWizard;
